<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormAddBanking"
        :width="40"
        @close="closeOverSide"
        @undo="undo()">
        <hts-card :title="$t('labels.bankingInformation')">
            <div
                class="grid gap-5"
                :class="columnClass">
                <hts-form-input
                    :required="true"
                    :label="$t('labels.companyName')"
                    :placeholder="companyName"
                    :color="props.color"
                    :disabled="true"
                    name="company"
                    prop="company" />
                <hts-form-input
                    v-model="dataFormAddBanking.bankingName"
                    :label="$t('labels.bankingName')"
                    :required="true"
                    :color="props.color"
                    name="bankingName"
                    prop="bankingName" />
                <hts-form-input
                    v-model="dataFormAddBanking.bankingAccountNumber"
                    :label="$t('labels.bankingAccountNumber')"
                    :required="true"
                    :color="props.color"
                    name="bankingAccountNumber"
                    prop="bankingAccountNumber" />
                <hts-form-input
                    v-model="dataFormAddBanking.bankingBranch"
                    :label="$t('labels.bankingBranch')"
                    :required="true"
                    :color="props.color"
                    name="bankingBranch"
                    prop="bankingBranch" />
                <hts-form-input
                    v-model="dataFormAddBanking.accountHolderName"
                    :label="$t('labels.accountName')"
                    :required="true"
                    :color="props.color"
                    name="accountHolderName"
                    prop="accountHolderName" />
            </div>
        </hts-card>
    </hts-slide-over>
</template>

<script setup lang="ts">
import bankingForm from './imports/banking-form'
const store = $store()
const companyName = ref('')
onMounted(() => {
  companyName.value = store.system.company.name
})
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  companyBranch: {
    type: Object,
    default: () => {}
  }
})
const dataFormAddBanking = reactive({ ...bankingForm.initBanking })
const emits = defineEmits(['close', 'refresh'])
const closeOverSide = () => {
  emits('close')
}
const undo = () => {
  Object.assign(dataFormAddBanking, { ...bankingForm.initBanking })
}
const handleSubmitFormAddBanking = () => {
  const api = $url.companyBranch.addBanking
  const dataRequest = { ...dataFormAddBanking, id: props.companyBranch._id }
  $api(api, { body: dataRequest })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        emits('refresh', dataFormAddBanking, 'add')
        Object.assign(dataFormAddBanking, { ...bankingForm.initBanking })
        process.client && $toast().success($t('labels.addBankingSuccess'))
        emits('close')
        undo()
      }
    })
    .catch(() => {
      process.client && $toast().error($t('labels.permissionsIsRequired'))
    })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-5'
})
</script>
